import { getNavIdFromTitle } from '@bob/library'

export const spotWrapperProps = (caption: string | null | undefined) => ({
  id: caption ? getNavIdFromTitle(caption) : undefined,
})
